import '../style/form-3xRaoggM.css'
import { defineComponent as te, useSlots as ne, ref as $, watch as H, computed as b, reactive as K, toRefs as N, onMounted as U, onBeforeUnmount as ie, provide as re, openBlock as D, createElementBlock as P, normalizeClass as T, createBlock as ue, unref as M, withCtx as W, createElementVNode as X, renderSlot as q, createTextVNode as G, toDisplayString as J, createCommentVNode as Q, createVNode as Y, Transition as ce, useCssVars as de, withModifiers as fe, shallowRef as me, nextTick as pe } from "vue";
import { debounce as ve, has as j, cloneDeep as Z } from "lodash-es";
import { hasOwn as he, NOOP as ge } from "@vue/shared";
import x from "async-validator";
import "x-utils";
import { toRef as ye, toValue as O, until as be, watchDebounced as Fe, toRefs as we } from "@vueuse/core";
import { useFormItem as Ee } from "./hooks/useFormItem.js";
import { useI18n as _e } from "./hooks/useLocale.js";
import "./hooks/useGlobalDark.js";
import "./layout/model/Model.js";
import "./layout/DockLocation.js";
import "./layout/Orientation.js";
import "./layout/model/TabNode.js";
import "./layout/model/TabSetNode.js";
import "./layout/model/BorderNode.js";
import { useInputSize as oe } from "./hooks/useInputSize.js";
import { SkeletonWrapper as ee } from "./skeleton.js";
import { ValidateStateEnum as A, formItemKey as Oe, formKey as Ve } from "./constant/form.js";
import { useElementId as Re } from "./hooks/useElementId.js";
import { BaseSizeEnum as ke } from "./constant/common.js";
import { useMobileView as Se } from "./hooks/useMobileView.js";
function C(p, e, F) {
  let n = p, o, v;
  if (p && he(p, e))
    o = e, v = n?.[e];
  else {
    e = e.replace(/\[(\w+)\]/g, ".$1"), e = e.replace(/^\./, "");
    const d = e.split(".");
    let c = 0;
    for (c; c < d.length - 1 && !(!n && !F); c++) {
      const s = d[c];
      if (s in n)
        n = n[s];
      else {
        if (F)
          throw new Error("please transfer a valid prop path to form item!");
        break;
      }
    }
    o = d[c], v = n?.[d[c]];
  }
  return {
    o: n,
    k: o,
    v
  };
}
const Ie = ["for"], Le = { class: "e-form-item__content" }, rt = /* @__PURE__ */ te({
  name: "e-form-item",
  __name: "form-item",
  props: {
    label: {},
    prop: {},
    required: { type: Boolean, default: void 0 },
    rules: {},
    error: { type: [String, Boolean] },
    debounce: { default: 500 },
    skeleton: {},
    emptyLabel: { type: Boolean }
  },
  setup(p) {
    const e = p, { t: F } = _e(), n = ne(), { form: o, formSize: v } = Ee(), { elementId: d } = Re("form-item"), { height: c } = oe({
      formSize: v,
      propSize: void 0
    }), s = $(A.Ready), f = $("");
    let u = !1, g;
    H(
      () => e.error,
      (t) => {
        f.value = typeof t == "string" ? t : "", s.value = t ? A.Error : A.Ready;
      },
      {
        immediate: !0
      }
    );
    const V = b(() => e.skeleton?.content?.height ?? c.value), I = b(() => o.skeleton), L = b(() => !!e.label || !!n.label || e.emptyLabel), R = b(() => s.value === A.Error), k = b(() => {
      const t = o.data;
      if (!t || !e.prop)
        return;
      let l = e.prop;
      return l.indexOf(":") !== -1 && (l = l.replace(/:/, ".")), C(t, l, !0).v;
    }), h = b(() => {
      const t = o.rules, l = e.rules, E = e.required !== void 0 ? { required: !!e.required } : [], _ = C(t, e.prop || "", !1), z = t ? _.o[e.prop || ""] || _.v : [];
      return [].concat(l || z || []).concat(E);
    });
    function w(t, l = ge) {
      if (!e.prop) {
        l();
        return;
      }
      if (u) return;
      const E = m(t);
      if ((!E || E.length === 0) && e.required === void 0) {
        l();
        return;
      }
      s.value = A.Validating;
      const _ = {};
      E && E.length > 0 && E.forEach((B) => {
        delete B.trigger;
      }), _[e.prop] = E;
      const z = new x(_), ae = o.data;
      return z.validate(ae, { firstFields: !0 }, (B, se) => {
        s.value = B ? A.Error : A.Success, f.value = B ? B[0].message || F("formItem.required") : "";
        const le = s.value === A.Success;
        l(le, B ? se : {}), o.emit?.(
          "validate-item",
          { prop: e.prop, valid: !B, errors: B, message: f.value }
        );
      });
    }
    const S = e.debounce ? ve(w, e.debounce) : w, a = w;
    function r() {
      s.value = A.Ready, f.value = "";
    }
    function i() {
      const t = o.data, l = k.value, E = e.prop;
      if (!E) return;
      u = !0;
      const _ = C(t, E, !0);
      o.model && j(o.model, _.k) ? o.model[_.k].value = Array.isArray(l) ? [].concat(g) : g : o.data && j(o.data, _.k) && (o.data[_.k] = Array.isArray(l) ? [].concat(g) : g), r();
      const z = setTimeout(() => {
        u = !1, clearTimeout(z);
      }, 500);
    }
    function m(t) {
      return h.value.filter((l) => !l.trigger || t === "" ? !0 : Array.isArray(l.trigger) ? l.trigger.indexOf(t) > -1 : l.trigger === t).map((l) => ({ ...l }));
    }
    const y = K({
      ...N(e),
      validateState: s,
      resetField: i,
      clearValidate: r,
      validate: S,
      immediateValidate: a,
      formItemId: d,
      isError: R
    });
    return U(() => {
      if (o.addField(y), e.prop) {
        const t = k.value;
        g = Array.isArray(t) ? [...t] : t;
      }
    }), ie(() => {
      o.removeField(y);
    }), re(Oe, y), (t, l) => (D(), P("div", {
      class: T(["e-form-item", {
        "e-form-item--has-label": L.value
      }])
    }, [
      L.value ? (D(), ue(M(ee), {
        key: 0,
        loading: I.value,
        class: "e-form-item__label",
        skeleton: {
          width: t.skeleton?.label?.width ?? "80px",
          height: t.skeleton?.label?.height ?? "20px"
        }
      }, {
        default: W(() => [
          X("label", {
            for: M(d),
            class: "e-form-item__label"
          }, [
            q(t.$slots, "label", {}, () => [
              G(J(t.emptyLabel ? " " : t.label), 1)
            ])
          ], 8, Ie)
        ]),
        _: 3
      }, 8, ["loading", "skeleton"])) : Q("", !0),
      Y(M(ee), {
        loading: I.value,
        class: "e-form-item__content",
        skeleton: {
          width: t.skeleton?.content?.width,
          height: V.value
        }
      }, {
        default: W(() => [
          X("div", Le, [
            q(t.$slots, "default")
          ])
        ]),
        _: 3
      }, 8, ["loading", "skeleton"]),
      Y(ce, { name: "error-transition" }, {
        default: W(() => [
          R.value ? (D(), P("div", {
            key: 0,
            class: T(["e-form-item__error", `e-form-item__error--${M(o).errorPosition}`])
          }, [
            q(t.$slots, "error", {}, () => [
              G(J(f.value), 1)
            ])
          ], 2)) : Q("", !0)
        ]),
        _: 3
      })
    ], 2));
  }
}), Ae = 992;
function Be(p) {
  const { layout: e, labelLayout: F, size: n } = p, { isMobile: o } = Se(Ae), v = (f) => typeof f == "string" ? f : o.value ? f.mobile : f.desktop, d = b(() => v(e.value)), c = b(() => v(F.value));
  return {
    classList: b(() => [
      "e-form",
      `e-form--${d.value}`,
      `e-form--label-${c.value}`,
      `e-form--${n.value}`
    ])
  };
}
const ot = /* @__PURE__ */ te({
  name: "e-form",
  __name: "form",
  props: {
    model: {},
    data: {},
    rules: {},
    layout: { default: "vertical" },
    labelLayout: { default: "vertical" },
    errorPosition: { default: "absolute" },
    validateOnMounted: { type: Boolean },
    skeleton: { type: Boolean },
    size: { default: ke.Medium }
  },
  emits: ["submit", "validate-item", "reset"],
  setup(p, { expose: e, emit: F }) {
    de((a) => ({
      e717aa22: M(f)
    }));
    const n = p, o = F, { layout: v, size: d, labelLayout: c } = N(n), { classList: s } = Be({
      layout: v,
      labelLayout: c,
      size: d
    }), { height: f } = oe({ formSize: d }), u = [], g = b(() => n.rules ? n.rules : n.model ? Object.entries(n.model).reduce((a, [r, i]) => (a[r] = i.rules ?? [], a), {}) : []), V = b(() => n.data ? n.data : n.model ? Object.entries(n.model).reduce((a, [r, i]) => (a[r] = i.value, a), {}) : {});
    H(
      g,
      () => {
        h();
      }
    );
    function I(a) {
      a.prop && u.push(a);
    }
    function L(a) {
      a.prop && u.splice(u.indexOf(a), 1);
    }
    function R() {
      if (!V.value) {
        console.warn("[X UI Warn][Form] data is required for resetFields to work.");
        return;
      }
      u.forEach((a) => {
        a.resetField();
      }), o("reset");
    }
    function k(a) {
      return (a?.length ? u.filter((i) => a.includes(i.prop)) : u).forEach((i) => {
        i.clearValidate();
      }), Promise.resolve();
    }
    async function h(a) {
      if (!V.value)
        return console.warn("[X UI Warn][Form] data is required for validate to work!"), !1;
      if (await k(), u.length === 0)
        return a?.(!0), !0;
      let r = !0, i = 0, m;
      for (const y of u)
        y.immediateValidate("", (t, l) => {
          t === !1 && (r = !1), m = { ...m, ...l }, ++i === u.length && (r && (m = void 0), a?.(r, m), o("submit", r, m));
        });
      return r;
    }
    function w(a, r) {
      a = [].concat(a);
      const i = u.filter((m) => a.indexOf(m.prop) !== -1);
      if (!u.length) {
        console.warn("[X UI Warn][Form] please pass correct props!");
        return;
      }
      i.forEach((m) => {
        m.validate("", r);
      });
    }
    const S = K({
      ...N(n),
      rules: g,
      data: V,
      validateFields: h,
      resetFields: R,
      clearValidates: k,
      validateField: w,
      addField: I,
      removeField: L,
      emit: o
    });
    return U(() => {
      n.validateOnMounted && h();
    }), re(Ve, S), e({
      validateFields: h,
      clearValidates: k,
      resetFields: R
    }), (a, r) => (D(), P("form", {
      class: T(M(s)),
      onSubmit: r[0] || (r[0] = fe(() => {
      }, ["prevent"]))
    }, [
      q(a.$slots, "default")
    ], 34));
  }
});
function at() {
  let p = () => {
  };
  function e(n, o) {
    let v = "";
    const d = Object.keys(n), c = d.map((s) => () => n[s]);
    p = H(c, (s, f) => {
      d.forEach(async (u, g) => {
        s[g] !== f[g] && !v && o[u] && (v = u, await o[u](s[g]), v = "");
      });
    });
  }
  function F() {
    return p;
  }
  return {
    watchFormData: e,
    getStopWatchHandler: F
  };
}
const Me = x.default || x;
function $e(p, e, F = {}) {
  const {
    validateOption: n = {},
    immediate: o = !0,
    manual: v = !1
  } = F, d = ye(p), c = me(null), s = $(!0), f = $(!o || v), u = b(() => c.value?.errors || []), g = b(() => {
    const h = c.value?.fields || {}, w = {};
    return Object.keys(h).forEach((S) => {
      const a = h[S];
      w[S] = a[0].message ?? "";
    }), w;
  }), V = b(() => Object.keys(O(e))), I = b(() => new Me(O(e))), L = async () => {
    s.value = !1, f.value = !1;
    try {
      await I.value.validate(d.value, n), f.value = !0, c.value = null;
    } catch (h) {
      c.value = h;
    } finally {
      s.value = !0;
    }
    return {
      pass: f.value,
      errors: u.value,
      errorFields: g.value,
      ruleKeys: V.value
    };
  };
  v || H(
    [d, I],
    () => L(),
    { immediate: o, deep: !0 }
  );
  const R = {
    isFinished: s,
    pass: f,
    errors: u,
    errorFields: g,
    execute: L,
    ruleKeys: V
  };
  function k() {
    return new Promise((h, w) => {
      be(s).toBe(!0).then(() => h(R)).catch((S) => w(S));
    });
  }
  return {
    ...R,
    then(h, w) {
      return k().then(h, w);
    }
  };
}
function st(p, e, F = {}) {
  const { debounce: n = 300, immediate: o = !1, excludeResetFields: v = [] } = F, d = Z(O(p)), c = $([]), s = K({});
  let f = d, u = !1;
  Fe(p, (r) => {
    if (r) {
      const i = [], m = O(e);
      Object.keys(r).forEach((y) => {
        r[y] !== f[y] && j(m, y) && i.push(y);
      }), c.value = i;
    }
    pe(async () => {
      if (u) {
        u = !1;
        return;
      }
      await h(c.value);
    }), f = Z(O(r));
  }, { immediate: !0, debounce: n });
  const g = $(["change"]), V = b(() => Object.values(O(s)).filter((r) => r != null).length > 0), I = b(() => {
    const r = O(p), i = O(e), m = {}, y = {};
    return c.value.forEach((t) => {
      const l = i[t];
      j(r, t) && Array.isArray(l) && (m[t] = r[t], y[t] = l.filter((E) => {
        const _ = E.trigger ?? "change";
        return g.value.includes(_);
      }));
    }), {
      model: m,
      rules: y
    };
  }), { model: L, rules: R } = we(I), {
    execute: k
  } = $e(L, R, {
    manual: !0
  }), h = async (r, i = ["change"]) => {
    g.value = i, c.value = r ?? Object.keys(O(e));
    const { pass: m, errorFields: y, ruleKeys: t } = await k();
    return t && t.forEach((l) => {
      y && j(y, l) ? s[l] = y[l] : s[l] = void 0;
    }), m;
  }, w = () => {
    u = !0;
    const r = O(p);
    Object.keys(d).forEach((i) => {
      v.includes(i) || (r[i] = d[i]);
    }), Object.keys(s).forEach((i) => {
      s[i] = void 0;
    });
  }, S = (r, i = ["change", "blur"]) => h(r, i), a = (r) => {
    (r ?? Object.keys(O(e))).forEach((m) => {
      s[m] = void 0;
    });
  };
  return U(() => {
    o && h();
  }), {
    validate: S,
    resetFields: w,
    clearError: a,
    errorFields: s,
    hasError: V
  };
}
export {
  rt as FormItem,
  ot as default,
  st as useForm,
  at as useFormDataWatcher
};
//# sourceMappingURL=form.js.map
